// Internationalization for registration form
export const translations = {
  fr: {
    // Header
    title: "Bon de souscription pour tester gratuitement 30 jours QualiteeMed",
    subtitle: "Période d'essai résiliable à tout moment",
    
    // Form fields
    email: "Email",
    password: "Mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    practitionerName: "Nom & prénom du praticien",
    clinicName: "Nom du cabinet",
    clinicAddress: "Adresse du cabinet",
    clinicCity: "Ville",
    clinicPostalCode: "Code postal",
    clinicPhone: "Numéro de téléphone",
    clinicSize: "Taille du cabinet",
    demoPreference: "Je souhaite une démonstration personnalisée",
    
    // Placeholders
    emailPlaceholder: "votre.email@exemple.com",
    passwordPlaceholder: "Votre mot de passe",
    confirmPasswordPlaceholder: "Confirmer le mot de passe",
    practitionerNamePlaceholder: "Dr. Jean Dupont",
    clinicNamePlaceholder: "Cabinet Dentaire Dupont",
    clinicAddressPlaceholder: "Rue de la Paix 123",
    clinicCityPlaceholder: "Genève",
    clinicPostalCodePlaceholder: "1200",
    clinicPhonePlaceholder: "+41 22 123 45 67",
    
    // Clinic size options
    clinicSizeOptions: {
      '1': '1 praticien',
      '2-5': '2-5 praticiens',
      '6-15': '6-15 praticiens'
    },
    
    // Validation messages
    required: "Ce champ est requis",
    emailInvalid: "L'adresse e-mail n'est pas valide",
    passwordMinLength: "Le mot de passe doit contenir au moins 8 caractères",
    passwordNoUpperCase: "Le mot de passe doit contenir au moins une majuscule",
    passwordNoLowerCase: "Le mot de passe doit contenir au moins une minuscule",
    passwordNoNumber: "Le mot de passe doit contenir au moins un chiffre",
    passwordsNotMatch: "Les mots de passe ne correspondent pas",
    postalCodeInvalid: "Le code postal doit contenir 4 chiffres",
    
    // Buttons
    submit: "Commencer l'essai gratuit",
    submitting: "Envoi en cours...",
    
    // Success message
    successTitle: "Merci pour votre inscription !",
    successMessage: "Votre demande d'essai gratuit a été envoyée avec succès. Notre équipe vous contactera dans les plus brefs délais pour activer votre compte.",
    backToWebsite: "Retourner sur QualiteeMed",
    
    // Help text
    helpTitle: "Besoin d'aide ?",
    helpDescription: "Pour toute question n'hésitez pas à nous contacter :",
    helpEmail: "info@qualiteemed.ai",
    helpPhone: "076 408 12 08",

    // Error messages
    emailAlreadyExists: "Une inscription avec cette adresse e-mail existe déjà",
    emailAlreadyUsed: "Cette adresse e-mail est déjà utilisée",
    submitError: "Une erreur est survenue lors de l'envoi. Veuillez réessayer."
  },
  
  en: {
    // Header
    title: "QualiteeMed 30-Day Free Trial Subscription Form",
    subtitle: "Trial period can be cancelled at any time",
    
    // Form fields
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm password",
    practitionerName: "Practitioner name",
    clinicName: "Clinic name",
    clinicAddress: "Clinic address",
    clinicCity: "City",
    clinicPostalCode: "Postal code",
    clinicPhone: "Phone number",
    clinicSize: "Clinic size",
    demoPreference: "I would like a personalized demonstration",
    
    // Placeholders
    emailPlaceholder: "your.email@example.com",
    passwordPlaceholder: "Your password",
    confirmPasswordPlaceholder: "Confirm password",
    practitionerNamePlaceholder: "Dr. John Smith",
    clinicNamePlaceholder: "Smith Dental Clinic",
    clinicAddressPlaceholder: "Peace Street 123",
    clinicCityPlaceholder: "Geneva",
    clinicPostalCodePlaceholder: "1200",
    clinicPhonePlaceholder: "+41 22 123 45 67",
    
    // Clinic size options
    clinicSizeOptions: {
      '1': '1 practitioner',
      '2-5': '2-5 practitioners',
      '6-15': '6-15 practitioners'
    },
    
    // Validation messages
    required: "This field is required",
    emailInvalid: "Email address is not valid",
    passwordMinLength: "Password must contain at least 8 characters",
    passwordNoUpperCase: "Password must contain at least one uppercase letter",
    passwordNoLowerCase: "Password must contain at least one lowercase letter",
    passwordNoNumber: "Password must contain at least one number",
    passwordsNotMatch: "Passwords do not match",
    postalCodeInvalid: "Postal code must contain 4 digits",
    
    // Buttons
    submit: "Start free trial",
    submitting: "Submitting...",
    
    // Success message
    successTitle: "Thank you for your registration!",
    successMessage: "Your free trial request has been sent successfully. Our team will contact you shortly to activate your account.",
    backToWebsite: "Back to QualiteeMed",
    
    // Help text
    helpTitle: "Need help?",
    helpDescription: "For any questions, please don't hesitate to contact us:",
    helpEmail: "info@qualiteemed.ai",
    helpPhone: "076 408 12 08",

    // Error messages
    emailAlreadyExists: "A registration with this email address already exists",
    emailAlreadyUsed: "This email address is already in use",
    submitError: "An error occurred while sending. Please try again."
  },
  
  de: {
    // Header
    title: "QualiteeMed 30-Tage kostenlose Testversion Abonnement",
    subtitle: "Testzeitraum kann jederzeit gekündigt werden",
    
    // Form fields
    email: "E-Mail",
    password: "Passwort",
    confirmPassword: "Passwort bestätigen",
    practitionerName: "Name des Praktikers",
    clinicName: "Praxisname",
    clinicAddress: "Praxisadresse",
    clinicCity: "Stadt",
    clinicPostalCode: "Postleitzahl",
    clinicPhone: "Telefonnummer",
    clinicSize: "Praxigröße",
    demoPreference: "Ich möchte eine personalisierte Demonstration",
    
    // Placeholders
    emailPlaceholder: "ihre.email@beispiel.com",
    passwordPlaceholder: "Ihr Passwort",
    confirmPasswordPlaceholder: "Passwort bestätigen",
    practitionerNamePlaceholder: "Dr. Hans Müller",
    clinicNamePlaceholder: "Zahnarztpraxis Müller",
    clinicAddressPlaceholder: "Friedensstraße 123",
    clinicCityPlaceholder: "Genf",
    clinicPostalCodePlaceholder: "1200",
    clinicPhonePlaceholder: "+41 22 123 45 67",
    
    // Clinic size options
    clinicSizeOptions: {
      '1': '1 Praktiker',
      '2-5': '2-5 Praktiker',
      '6-15': '6-15 Praktiker'
    },
    
    // Validation messages
    required: "Dieses Feld ist erforderlich",
    emailInvalid: "E-Mail-Adresse ist nicht gültig",
    passwordMinLength: "Passwort muss mindestens 8 Zeichen enthalten",
    passwordNoUpperCase: "Passwort muss mindestens einen Großbuchstaben enthalten",
    passwordNoLowerCase: "Passwort muss mindestens einen Kleinbuchstaben enthalten",
    passwordNoNumber: "Passwort muss mindestens eine Ziffer enthalten",
    passwordsNotMatch: "Passwörter stimmen nicht überein",
    postalCodeInvalid: "Postleitzahl muss 4 Ziffern enthalten",
    
    // Buttons
    submit: "Kostenlose Testversion starten",
    submitting: "Wird gesendet...",
    
    // Success message
    successTitle: "Vielen Dank für Ihre Anmeldung!",
    successMessage: "Ihre Anfrage für eine kostenlose Testversion wurde erfolgreich gesendet. Unser Team wird Sie in Kürze kontaktieren, um Ihr Konto zu aktivieren.",
    backToWebsite: "Zurück zu QualiteeMed",
    
    // Help text
    helpTitle: "Brauchen Sie Hilfe?",
    helpDescription: "Bei Fragen zögern Sie nicht, uns zu kontaktieren:",
    helpEmail: "info@qualiteemed.ai",
    helpPhone: "076 408 12 08",

    // Error messages
    emailAlreadyExists: "Eine Registrierung mit dieser E-Mail-Adresse existiert bereits",
    emailAlreadyUsed: "Diese E-Mail-Adresse wird bereits verwendet",
    submitError: "Beim Senden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."
  },
  
  it: {
    // Header
    title: "QualiteeMed Abbonamento Prova Gratuita 30 Giorni",
    subtitle: "Periodo di prova cancellabile in qualsiasi momento",
    
    // Form fields
    email: "Email",
    password: "Password",
    confirmPassword: "Conferma password",
    practitionerName: "Nome del professionista",
    clinicName: "Nome della clinica",
    clinicAddress: "Indirizzo della clinica",
    clinicCity: "Città",
    clinicPostalCode: "Codice postale",
    clinicPhone: "Numero di telefono",
    clinicSize: "Dimensione della clinica",
    demoPreference: "Vorrei una dimostrazione personalizzata",
    
    // Placeholders
    emailPlaceholder: "vostra.email@esempio.com",
    passwordPlaceholder: "La vostra password",
    confirmPasswordPlaceholder: "Conferma password",
    practitionerNamePlaceholder: "Dr. Mario Rossi",
    clinicNamePlaceholder: "Clinica Dentale Rossi",
    clinicAddressPlaceholder: "Via della Pace 123",
    clinicCityPlaceholder: "Ginevra",
    clinicPostalCodePlaceholder: "1200",
    clinicPhonePlaceholder: "+41 22 123 45 67",
    
    // Clinic size options
    clinicSizeOptions: {
      '1': '1 professionista',
      '2-5': '2-5 professionisti',
      '6-15': '6-15 professionisti'
    },
    
    // Validation messages
    required: "Questo campo è obbligatorio",
    emailInvalid: "L'indirizzo email non è valido",
    passwordMinLength: "La password deve contenere almeno 8 caratteri",
    passwordNoUpperCase: "La password deve contenere almeno una lettera maiuscola",
    passwordNoLowerCase: "La password deve contenere almeno una lettera minuscola",
    passwordNoNumber: "La password deve contenere almeno un numero",
    passwordsNotMatch: "Le password non corrispondono",
    postalCodeInvalid: "Il codice postale deve contenere 4 cifre",
    
    // Buttons
    submit: "Inizia prova gratuita",
    submitting: "Invio in corso...",
    
    // Success message
    successTitle: "Grazie per la vostra registrazione!",
    successMessage: "La vostra richiesta di prova gratuita è stata inviata con successo. Il nostro team vi contatterà a breve per attivare il vostro account.",
    backToWebsite: "Torna a QualiteeMed",
    
    // Help text
    helpTitle: "Avete bisogno di aiuto?",
    helpDescription: "Per qualsiasi domanda, non esitate a contattarci:",
    helpEmail: "info@qualiteemed.ai",
    helpPhone: "076 408 12 08",

    // Error messages
    emailAlreadyExists: "Esiste già una registrazione con questo indirizzo email",
    emailAlreadyUsed: "Questo indirizzo email è già in uso",
    submitError: "Si è verificato un errore durante l'invio. Riprovate."
  }
};

// Language detection
export const detectLanguage = () => {
  // Check URL parameter first
  const urlParams = new URLSearchParams(window.location.search);
  const urlLang = urlParams.get('lang');
  if (urlLang && translations[urlLang]) {
    return urlLang;
  }
  
  // Check localStorage
  const storedLang = localStorage.getItem('registration-language');
  if (storedLang && translations[storedLang]) {
    return storedLang;
  }
  
  // Check browser language
  const browserLang = navigator.language.split('-')[0];
  if (translations[browserLang]) {
    return browserLang;
  }
  
  // Default to French
  return 'fr';
};

// Set language
export const setLanguage = (lang) => {
  if (translations[lang]) {
    localStorage.setItem('registration-language', lang);
    return lang;
  }
  return 'fr';
};
